import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import compareStyles from "../styles/compare.css?url";
import { withStylesheet } from "../lib/head";
import { AlternativePage, Comparison } from "../platform/compare/compare-pages";
import { loadComparePage } from "../platform/compare";
import { platformPageHead, platformShellFrom } from "../platform/head";

/**
 * /compare/<platform> and /compare/<platform>-alternative (Drate's host only). A comparison Drate
 * no longer publishes sends its visitors to /compare, and one that moved to its platform's
 * alternative page sends them there, both for good (comparePage in compare.server.ts).
 */
export const Route = createFileRoute("/compare/$slug")({
  loader: async ({ params }) => {
    const page = await loadComparePage({ data: params.slug });
    if (!page) throw notFound();
    if (page.kind === "redirect") throw redirect({ href: page.to, statusCode: 301 });
    return page;
  },
  head: ({ matches, loaderData, match }) => {
    if (!loaderData) return {};
    const shell = platformShellFrom(matches);
    const head =
      loaderData.kind === "alternative"
        ? platformPageHead(shell, {
            pathname: match.pathname,
            title: loaderData.title,
            description: loaderData.description,
            structuredData: loaderData.structuredData,
          })
        : platformPageHead(shell, {
            pathname: match.pathname,
            title: `Drate vs ${loaderData.name}: features and fees compared | Drate`,
            description: loaderData.summary,
            structuredData: loaderData.structuredData,
          });
    return withStylesheet(head, compareStyles);
  },
  component: ComparePage,
});

function ComparePage() {
  const page = Route.useLoaderData();
  return page.kind === "alternative" ? <AlternativePage page={page} /> : <Comparison page={page} />;
}
